import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Observable } from 'rxjs';
import { SaveProfileRequest } from './master-create-user-model';

const BASE_PATH = environment.basePath;
const REST_PATH = environment.basePathExternal
const headers = new HttpHeaders({ 'Content-Type': 'application/json' });

@Injectable({
  providedIn: 'root',
})
export class MasterCreateUserService {
  private urlpost = `${BASE_PATH}/bff/master/users/create`;

  constructor(private http: HttpClient) {}

  postForm(salvar: any): Observable<any> {
    if (salvar === null || salvar === undefined) {
      console.log('Salvar undefined');
      return;
    }
    return this.http.post<any>(`${this.urlpost}`, salvar, { headers: headers });
  }

  saveProfile(payload: SaveProfileRequest): Observable<any> {
    return this.http.post(
      `${BASE_PATH}/bff/master-bo/users/create/profile/save`,
      payload,
      { headers: headers },
    );
  }

  createUser(payload: any): Observable<any> {
    return this.http.post(`${BASE_PATH}/bff/master-bo/users/create`, payload, {
      headers: headers,
    });
  }

  /**
   * Single Sign On (SSO) APIs
   */

  /**
   * API for creating user SSO
   * @param payload
   * @returns
   */
  createUserSSO(createUserPayload: any,saveProfilePayload: any):Observable<any> {
    let body ={}
      let cpf = createUserPayload.cpf.replaceAll(".","")
      cpf = cpf.replaceAll("-","")
       body = {
        "cpf": cpf,
        "email": createUserPayload.email,
        "idioma": createUserPayload.idioma == "português" ? "pt-BR" : "en-US",
        "nomeUsuario": createUserPayload.nomeUsuario,
        "perfil": createUserPayload.perfil,
        "usuario":createUserPayload.usuario,
        "ususarioMaster": createUserPayload.ususarioMaster
      }


    return this.http.post(`${REST_PATH}/registerUserSSO`,body,{
      headers: headers,
    });
  }

  /**
   * API for updating user SSO
   * @param payload
   * @returns
   */
  updateUserSSO(payload: any,userSso :any,usuarioMaster:any):Observable<any> {
    let cpf = payload.cpf
    cpf =cpf.replaceAll(".", "")
    cpf = cpf.replaceAll("-", "")
       let body = {
        "cpf": cpf,
        "email": payload.email,
        "idioma": payload.idioma == "português" ? "pt-BR" : "en-US",
        "nomeUsuario": payload.nomeUsuario,
        "perfil": payload.perfil,
        "usuario":payload.usuario,
        "usuarioMaster": usuarioMaster
      }

    return this.http.post(`${REST_PATH}/alterUserSSO`,body,{
      headers: headers,
    });
  }

  /**
   * API for consulting user SSO
   * @param payload
   * @returns
   */
  consultUserSSO(createUserPayload: any):Observable<any> {
    let body = {
      "usuario":createUserPayload.name,
      "usuarioMaster":createUserPayload.login,
      "cpf":createUserPayload.cpf
  }
    return this.http.post(`${REST_PATH}/consultUserSSO`,body,{
      headers: headers,
    });
  }
  consultUserSSOPassivo(createUserPayload: any, parentSSO:any):Observable<any> {
    let body = {
      "usuario":createUserPayload.name,
      "usuarioMaster":parentSSO,
      "cpf":createUserPayload.cpf
  }
    return this.http.post(`${REST_PATH}/consultUserSSO`,body,{
      headers: headers,
    });
  }
  

  /**
   * Block/unblock API for user SSO
   * @param createUserPayload
   * @returns
   */
  blockUserSSO(createUserPayload: any,usuarioMaster:any):Observable<any>{
    let body = {
      "usuario":createUserPayload.userSso,
      "usuarioMaster":usuarioMaster,
      "cpf": createUserPayload.cpf
  }
    return this.http.post(`${REST_PATH}/disableUserSSO`,body,{
      headers: headers,
    });
  }

  /**
   * get user creator of connected user
   * @param username
   * @returns
   */
  getCreatedUser(id: any): Observable<any>{
    return this.http.get<any>(
      `${REST_PATH}/userEntities/${id}`
    )
  }

  getCreatorUser(email: any): Observable<any> {

    return this.http.get<any>(
      `${REST_PATH}/userEntities/search?criteria=login=="${email}"`
    )
  }
}
